module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-complete-item attribute row text-center"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "badge att-field order"
  }, [_vm._v(_vm._s(_vm.order))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "att-field description"
  }, [_vm._v(_vm._s(_vm.criteria.descricao))])]), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "att-field status"
  }, [_vm._v(_vm._s(_vm.$t(_vm.criteria.ativo != null ? (_vm.criteria.ativo ? 'planoConciliacao.labels.ativo' : 'planoConciliacao.labels.inativo') : null)))])]), _c('div', {
    staticClass: "col-md-2 pull-right"
  }, [_c('div', {
    staticClass: "att-field buttons"
  }, [_c('button', {
    staticClass: "fa fa-pencil action",
    attrs: {
      "type": "button",
      "title": _vm.btnEditTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleEdit(_vm.criteria)
      }
    }
  }), _c('button', {
    staticClass: "fa fa-times action",
    attrs: {
      "type": "button",
      "disabled": _vm.criteria.criterioEmUso,
      "title": _vm.btnRemoveTitle
    },
    on: {
      "click": function($event) {
        return _vm.handleRemove(_vm.criteria)
      }
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1a206fcb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a206fcb"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/registration/conciliationPlan/conciliationCriteria/conciliationCriteria.pug
// module id = 1376
// module chunks = 0